// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hostess-income-rank-base{width:100%;min-height:calc(100vh - 4rem)}", ""]);
// Exports
module.exports = exports;
